export const MAKE_SAVED_SEARCH_TEAM_MESSAGE: string = 'This saved search is currently set to Private, but needs to be Team available to use in your automation. Select continue below to update its availability.';


